import Metismenu from "metismenujs";
import React, { useContext, useEffect, useRef, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link, useLocation } from "react-router-dom";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";
import checkPermissions from "../../global-functions/checkPermissionsFunc";
import { useTranslation } from "react-i18next";
import menuConfig from "../../../config/menuConfig";
// --- MetisMenu Wrapper ---
const MM = ({ children }) => {
  const ref = useRef(null);

  useEffect(() => {
    let mm;
    if (ref.current) {
      mm = new Metismenu(ref.current);
    }

    return () => {
      if (mm && mm.dispose) {
        mm.dispose();
      }
    };
  }, [children]);

  return (
    <div className="mm-wrapper">
      <ul className="metismenu" ref={ref}>
        {children}
      </ul>
    </div>
  );
};

const SideBar = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const { iconHover, sidebarposition, headerposition, sidebarLayout } =
    useContext(ThemeContext);

  const user = JSON.parse(localStorage.getItem("user"));
  const userRoleName = user?.roleName?.toLowerCase();

  // Handle toggle
  useEffect(() => {
    const btn = document.querySelector(".nav-control");
    const wrapper = document.querySelector("#main-wrapper");
    const heart = document.querySelector(".heart");

    const toggleMenu = () => wrapper?.classList.toggle("menu-toggle");
    const heartBlast = () => heart?.classList.toggle("heart-blast");

    btn?.addEventListener("click", toggleMenu);
    heart?.addEventListener("click", heartBlast);

    return () => {
      btn?.removeEventListener("click", toggleMenu);
      heart?.removeEventListener("click", heartBlast);
    };
  }, []);

  // Scroll handling
  const [hideOnScroll, setHideOnScroll] = useState(true);
  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y;
      if (isShow !== hideOnScroll) setHideOnScroll(isShow);
    },
    [hideOnScroll]
  );

  const path = window.location.pathname.split("/").pop();

  // ---- Menu Config ----
  const menus = [...menuConfig];

  // ---- Helpers ----
  const hasPermission = (permissions) =>
    !permissions || checkPermissions(permissions, null, null, "boolean");

  return (
    <div
      className={`dlabnav ${iconHover} ${
        sidebarposition.value === "fixed" &&
        sidebarLayout.value === "horizontal" &&
        headerposition.value === "static"
          ? hideOnScroll > 120
            ? "fixed"
            : ""
          : ""
      }`}
    >
      <PerfectScrollbar className="dlabnav-scroll">
        <MM>
          {menus.map(
            (menu) =>
              hasPermission(menu.permissions) && (
                <li
                  key={menu.key}
                  className={
                    menu.children.some(
                      (c) =>
                        location.pathname === c.key ||
                        location.pathname.startsWith(c.key + "/")
                    )
                      ? "mm-active"
                      : ""
                  }
                >
                  <Link className="has-arrow" to="#">
                    <i className={menu.icon}></i>
                    <span className="nav-text">{t(menu.label)}</span>
                  </Link>
                  <ul>
                    {menu.children.map(
                      (child) =>
                        (!child.permission ||
                          checkPermissions(
                            child.permission,
                            null,
                            null,
                            "boolean"
                          )) && (
                          <li key={child.key}>
                            <Link
                              className={
                                location.pathname === child.key ||
                                location.pathname.startsWith(child.key + "/")
                                  ? "mm-active"
                                  : ""
                              }
                              to={child.path}
                            >
                              {t(child.label)}
                            </Link>
                          </li>
                        )
                    )}
                  </ul>
                </li>
              )
          )}
        </MM>

        {/* Footer */}
        <div className="copyright">
          <p>
            <strong>Top Growth Network</strong> © {new Date().getFullYear()} All
            Rights Reserved
          </p>
          <p className="fs-12">
            Made with <span className="heart"></span> by Topgrowth
          </p>
        </div>
      </PerfectScrollbar>
    </div>
  );
};

export default SideBar;
